<template>
    <div class="content">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <a data-toggle="collapse" href="#searchdebtor" role="button" aria-expanded="false" aria-controls="searchdebtor">
            {{ $t('app.find_debtor') }}
          </a>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="datatable_filter float-right">
            <div class="row">
              <div class="col">
                <label>
                  <select v-model="tableData.length" @change="fetchDebtors()" class="form-control form-control-sm">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="collapse" id="searchdebtor">
        <div class="card card-body mb-3">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="lastname" class="col-form-label">{{ $t('debtors.lastname') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_lastname')" id="lastname" v-model="filter.lastname">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="name" class="col-form-label">{{ $t('debtors.firstname') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_firstname')" id="name" v-model="filter.firstname">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="middlename" class="col-form-label">{{ $t('debtors.middlename') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_middlename')" id="middlename" v-model="filter.middlename">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="iin" class="col-form-label">{{ $t('debtors.iin') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_iin')" id="iin" v-model="filter.iin">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="birth_day" class="col-form-label">{{ $t('debtors.birth_day') }}</label>
                  <input type="date" class="form-control form-control-sm" id="birth_day" v-model="filter.birth_day">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="phone" class="col-form-label">{{ $t('phones.phone') }}</label>
                  <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_phone')" id="phone" v-model="filter.phone">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <div class="btn-group ">
                  <button class="btn btn-primary" @click="findDebtors()">{{ $t('field.find') }}</button>
                  <button class="btn btn-danger" @click="resetForm()">{{ $t('field.reset') }}</button>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="block">
        <div class="block-header">
          {{ $t('debtors.index') }} {{pagination.total ? '(' + pagination.total + ')': '' }}
        </div>
        <div class="table-responsive">
          <datatable class="m-0" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" :loading="loadDebtors" @sort="sortBy" >
              <tbody>
                <tr v-for="(debtor, index) in debtors" :key="debtor.id">
                  <td>{{index+1}}</td>
                  <td>
                    <div class="btn-group">
                      <a :href="'/admin/debtors/' + debtor.id" class="btn btn-primary btn-sm" target="_blank" title="Открыть">
                        <i class="fa fa-eye"></i>
                      </a>
                    </div>
                  </td>
                  <td>{{debtor.fullname}}</td>
                  <td>{{debtor.iin}}</td>
                  <td>
                    <span v-if="debtor.id_card_number">
                      <strong>{{ $t('debtors.id_card_number') }}</strong> {{debtor.id_card_number}}<br>
                    </span>
                    <span v-if="debtor.id_card_who_issued">
                      <strong>{{ $t('debtors.id_card_who_issued') }}</strong> {{debtor.id_card_who_issued}}<br>
                    </span>
                    <span v-if="debtor.id_card_start_data">
                      <strong>{{ $t('debtors.id_card_start_date') }}</strong> {{debtor.id_card_start_data}}<br>
                    </span>
                    <span v-if="debtor.id_card_end_date">
                      <strong>{{ $t('debtors.id_card_end_date') }}</strong> {{debtor.id_card_end_date}}
                    </span>
                  </td>
                  <td>{{debtor.debts_count ? (debtor.debts_count[0] ? debtor.debts_count[0].aggregate: '0' ): '0' }}</td>
                  <td>{{debtor.created_at | datetimeFormat}}</td>
                </tr>
                <tr v-if="debtors.length == 0 && !loadDebtors">
                  <td colspan="12" class="text-center">{{ $t('app.empty') }}</td>
                </tr>
              </tbody>
          </datatable>
        </div>
      </div>
      <pagination :pagination="pagination" :offset="4" @paginate="fetchDebtors()"/>
    </div>
</template>

<script>
export default {
  data() {
    return {
      debtors: [],
      columns: [
        { label: '#', name: 'index', disableOrder: true },
        { label: '', name: 'action', disableOrder: true },
        { label: this.$t('debtors.fullname'), name: 'debtors.fullname' },
        { label: this.$t('debtors.iin'), name: 'debtors.iin' },
        { label: this.$t('debtors.data_from_id_card'), name: 'debtors.id_card_number' },
        { label: this.$t('debtors.debts_count'), name: 'debts_count' },
        { label: this.$t('debtors.created_at'), name: 'created_at' },
      ],
      sortKey: 'name',
      sortOrders: {},
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'asc',
      },
      update_errors: {},
      filter: {
        lastname: this.$route.query.lastname,
        firstname: this.$route.query.firstname,
        middlename: this.$route.query.middlename,
        iin: this.$route.query.iin,
        birth_day: this.$route.query.birth_day,
        phone: this.$route.query.phone,
      },
      pagination: {
        current_page: 1,
      },
      loadDebtors: false,
      isProcessing: false,
    };
  },
  created() {
    this.fetchDebtors();
    this.columns.forEach((column) => {
      this.sortOrders[column.name] = -1;
    });
  },
  methods: {
    findDebtors() {
      this.pagination.current_page = 1;
      this.fetchDebtors();
    },

    fetchDebtors() {
      this.loadDebtors = true;
      this.tableData.draw += 1;
      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`/admin/debtors?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.debtors = res.data.debtors.data;
            this.pagination = this.laraPaginate(res.data.debtors);
          } else {
            console.log('failed');
          }
        })
        .catch((err) => {
          this.laravelValidation(err);
        })
        .finally(() => {
          this.loadDebtors = false;
        });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchDebtors();
    },

    resetForm() {
      this.filter.lastname = '';
      this.filter.firstname = '';
      this.filter.middlename = '';
      this.filter.iin = '';
      this.filter.birth_day = '';
      this.filter.phone = '';
      this.pagination.current_page = 1;
      this.fetchDebtors();
    },
  },
};
</script>
